/**
 * created by lei lei
 *
 */
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import Editors from"./Editors"
import {savePicAndArt} from "../../../actions/weiChat";
export default class EditorsDemo extends Component {
    static defaultProps = {};
    static propTypes = {};

    constructor(props) {
        super(props);
        this.state = {}
    }

    componentWillMount() {
    }

    componentDidMount() {
    }

    render() {
        return (
            <div className={'demo'} style={{display: 'flex', flexDirection:'column'}}>
                <Editors
                    content={this.state.content}
                    isUpDate={this.state.isUpDate}
                    imgBtnShow={true}
                    xiuMiBtnShow={true}
                    wordImportBtnShow={true}
                    oneTypesettingBtnShow={true}
                   /* stuffId={this.state.stuffList[this.state.currentItemIndex]&&this.state.stuffList[this.state.currentItemIndex].id?this.state.stuffList[this.state.currentItemIndex].id:0}
                    xiumiIdCallBack={(id)=>{
                        console.log('秀米id',id);
                        this.state.stuffList[this.state.currentItemIndex].fromId=id;
                        let params = {id: this.state.materialId,mediaCode: this.props.mediaCode,stuffList:this.state.stuffList,isAdd:this.state.isAdd};
                        savePicAndArt(params,(res) => {
                            if(res&&res.data&&res.data.id){
                                this.state.stuffList[this.state.currentItemIndex].id=res.data.stuffList[this.state.currentItemIndex].id;
                                this.state.stuffList.forEach(item=>{
                                    item.materialId=res.data.id;
                                });//给每一条stuff数据都加上materialId
                                this.setState({materialId:res.data.id})
                            }
                            console.log('秀米返回数据保存')
                        });
                        this.setState({})
                    }}*/
                    callBackeditorContent={(data) => {
                        console.log(data)
                    }}
                />
            </div>
        )
    }

}